import { GlButton, GlEmptyState, GlLoadingIcon } from '@gitlab/ui';
import emptyStateSvg from '@gitlab/svgs/dist/illustrations/status/status-new-sm.svg';
import { renderGFM } from '~/behaviors/markdown/render_gfm';
import { destroyImageLightbox } from '~/behaviors/markdown/render_image_lightbox';
import SafeHtml from '~/vue_shared/directives/safe_html';
import DuoChatQuickAction from 'ee/ai/shared/widgets/duo_chat_quick_action.vue';
import { buildWorkplanChatCommand } from './constants';
export default {
    name: 'WorkplanView',
    directives: {
        SafeHtml
    },
    components: {
        GlButton,
        GlEmptyState,
        GlLoadingIcon,
        DuoChatQuickAction
    },
    emptyStateSvg,
    props: {
        isLoading: {
            type: Boolean,
            required: true
        },
        canUpdate: {
            type: Boolean,
            required: true
        },
        savedContent: {
            type: String,
            required: true
        },
        savedContentHtml: {
            type: String,
            required: true
        },
        workItemId: {
            type: String,
            required: true
        },
        workItemWebUrl: {
            type: String,
            required: true
        },
        isFlowActive: {
            type: Boolean,
            required: false,
            default: false
        },
        canGenerateAsync: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'start-edit',
        'generate'
    ],
    computed: {
        isRegenerating () {
            return this.isFlowActive && this.hasSavedContent;
        },
        hasSavedContent () {
            return Boolean(this.savedContent);
        },
        generateWorkplanQuickAction () {
            return {
                command: buildWorkplanChatCommand(this.workItemWebUrl),
                tracking: {
                    label: 'create_work_plan'
                },
                buttonOptions: {
                    variant: 'confirm',
                    category: 'primary'
                }
            };
        }
    },
    watch: {
        savedContentHtml: {
            handler () {
                this.renderMarkdown();
            },
            immediate: true
        }
    },
    beforeDestroy () {
        if (this.$refs['gfm-content']) {
            destroyImageLightbox(this.$refs['gfm-content']);
        }
    },
    methods: {
        async renderMarkdown () {
            await this.$nextTick();
            renderGFM(this.$refs['gfm-content']);
        }
    }
};
